<div class="titulo">
    <h2>
        <p>Cadastre-se e comece a <span> EXPERIMENTAR GRÁTIS</span></p>
    </h2>
</div>

<div class="form" id="form-account">
    <form [id]="idForm"></form>
</div>